"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModalHeadingIcon = exports.StyledModalHeading = exports.StyledModalHeader = exports.StyledModalCloseButton = exports.StyledModalBackButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _iconElement = require("../../fuse-icon-element/src/icon-element");
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography/src/typography");
var _typography2 = require("../../fuse-typography-element/src/typography");
var _defaultCssProps$t, _iconButtonSizeConfig;
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var modalHeadingHeight = (0, _typography.convertRemToPx)(_typography.defaultCssProps === null || _typography.defaultCssProps === void 0 || (_defaultCssProps$t = _typography.defaultCssProps.t3) === null || _defaultCssProps$t === void 0 ? void 0 : _defaultCssProps$t.lineHeight);
var headerButtonHeight = (_iconButtonSizeConfig = _buttons.iconButtonSizeConfig.small) === null || _iconButtonSizeConfig === void 0 || (_iconButtonSizeConfig = _iconButtonSizeConfig.iconHeight) === null || _iconButtonSizeConfig === void 0 ? void 0 : _iconButtonSizeConfig.replace('px', '');
var iconAndButtonMarginTop = "".concat((modalHeadingHeight - headerButtonHeight) / 2, "px");
var StyledModalHeader = exports.StyledModalHeader = _styledComponents["default"].div.attrs({
  className: 'fuse-modal__header',
  'data-testid': 'fuse-modal__header'
}).withConfig({
  displayName: "styled-modal-header__StyledModalHeader",
  componentId: "sc-g2fixn-0"
})(["", ""], function (_ref) {
  var hasDepth = _ref.hasDepth;
  return "\n\t\talign-items: center;\n\t\tbackground-color: var(--color-functional-panelLight);\n\t\tborder-bottom: 1px solid var(--color-functional-divider);\n        border-top-left-radius: inherit;\n        border-top-right-radius: inherit;\n\t\tcolor: var(--color-global-black);\n\t\tdisplay: flex;\n        flex-shrink: 0; /* Required for safari mobile ios < 14.7 so that modal header height isn't shrink and adjusts dynamically to its content */\n\t\tleft: 0;\n\t\tpadding: ".concat(_grid.gridConfig.xxs.margin, ";\n\t\ttop: 0;\n\t\ttransition: box-shadow 50ms ease-in-out;\n\t\twidth: 100%;\n\t\tz-index: 1;\n\n\t\t").concat(hasDepth ? "\n\t\t\t\t\t\tbox-shadow: var(--elevation-shadow-l);\n\t\t\t\t  " : "", "\n\n\t\t@media only screen and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\tpadding: ").concat(_grid.gridConfig.m.margin, ";\n\t\t\t").concat(hasDepth ? "\n\t\t\t\t\t\t\tbox-shadow: var(--elevation-shadow-xl);\n\t\t\t\t\t  " : "", "\n\t\t}\n\n        @media only screen and (min-width: ").concat(_grid.gridConfig.xl.minWidth, ") {\n\t\t\t").concat(hasDepth ? "\n\t\t\t\t\t\t\tbox-shadow: var(--elevation-shadow-xxl);\n\t\t\t\t\t  " : "", "\n\t\t}\n\t");
});
var StyledModalBackButton = exports.StyledModalBackButton = (0, _styledComponents["default"])(_buttons.PlainIconButton).attrs({
  className: 'fuse-modal__back-button',
  'data-testid': 'fuse-modal__back-button'
}).withConfig({
  displayName: "styled-modal-header__StyledModalBackButton",
  componentId: "sc-g2fixn-1"
})(["margin-top:", ";"], iconAndButtonMarginTop);
var StyledModalHeadingIcon = exports.StyledModalHeadingIcon = (0, _styledComponents["default"])(_iconElement.Icon).attrs({
  className: 'fuse-modal__header-icon',
  'data-testid': 'fuse-modal__header-icon'
}).withConfig({
  displayName: "styled-modal-header__StyledModalHeadingIcon",
  componentId: "sc-g2fixn-2"
})(["margin-top:", ";"], iconAndButtonMarginTop);
var StyledModalHeading = exports.StyledModalHeading = (0, _styledComponents["default"])(_typography2.TypographyComponent).attrs({
  className: 'fuse-modal__heading',
  'data-testid': 'fuse-modal__heading'
}).withConfig({
  displayName: "styled-modal-header__StyledModalHeading",
  componentId: "sc-g2fixn-3"
})(["", ""], function (_ref2) {
  var hasBackButton = _ref2.hasBackButton,
    headerIcon = _ref2.headerIcon;
  return "\n\t\tflex: 1 1 auto;\n\t\t".concat(hasBackButton || headerIcon ? "margin-left: var(--spacing-global-space3);" : "", "\n\t");
});
var StyledModalCloseButton = exports.StyledModalCloseButton = (0, _styledComponents["default"])(_buttons.PlainIconButton).attrs({
  className: 'fuse-modal__close-button',
  'data-testid': 'fuse-modal__close-button'
}).withConfig({
  displayName: "styled-modal-header__StyledModalCloseButton",
  componentId: "sc-g2fixn-4"
})(["margin-left:var(--spacing-global-space3);margin-top:", ";"], iconAndButtonMarginTop);